import {Component, inject} from '@angular/core'
import {FilterService} from '../../services/filter.service'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {MatIconButton} from '@angular/material/button'
import {RouterLink, RouterLinkActive} from '@angular/router'
import {MatDivider} from '@angular/material/divider'
import {MatIcon} from '@angular/material/icon'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {RoleHelperService} from '../../services/role-helper.service'
import {MatDialog} from '@angular/material/dialog'
import {SelectComponent} from '../pre-bound/select/select.component'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  imports: [
    LogoComponent,
    MatMenuTrigger,
    MatMenu,
    RouterLink,
    MatMenuItem,
    RouterLinkActive,
    MatDivider,
    MatIcon,
    ToggleButtonComponent,
    MatIconButton
  ],
  styleUrls: ['./header.component.scss']

})
export class HeaderComponent {
  public configService = inject(ConfigService)
  public filterService = inject(FilterService)
  public roles = inject(RoleHelperService)

  private dialog = inject(MatDialog)

  public preBound() {
    this.dialog.open(SelectComponent, {})
  }
}
